import React from 'react';
import { useReducer } from 'react';
import '../App.css'; // Import the CSS for styling
import {reducer, initialState} from '../reducers/reducers'
const Popup = ({ onClose, children,title }) => {

  
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className='title-modal'>{title}<button className="button-close" onClick={onClose}
        style={{backgroundColor: '#8B0000', color: 'white', border: 'none', padding: '5px 10px', 
        borderRadius: '20%', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold', 
        marginLeft: '10px'}}>X</button></div>
        {children}
      </div>
    </div>
  );
};

export default Popup;